export const REQUEST_MY_EVENT_STREAMS = 'REQUEST_MY_EVENT_STREAMS'
export const RECEIVE_MY_EVENT_STREAMS = 'RECEIVE_MY_EVENT_STREAMS'
export const REMOVE_MY_EVENT_STREAM = 'REMOVE_MY_EVENT_STREAM'
export const UPDATE_MY_EVENT_STREAM = 'UPDATE_MY_EVENT_STREAM'

const requestMyEventsStreams = () => ({
  type: REQUEST_MY_EVENT_STREAMS
})

const receiveMyEventsStreams = (streams) => ({
  type: RECEIVE_MY_EVENT_STREAMS,
  streams
})

const removeMyEvent = (eventId) => ({
  type: REMOVE_MY_EVENT_STREAM,
  eventId
})

const updateMyEvent = (stream) => ({
  type: UPDATE_MY_EVENT_STREAM,
  stream: {
    ...stream,
    avatarBytes: stream.avatarPreview.slice(22)
  }
})

export const fetchMyEventsSterams = userId => dispatch => {
  dispatch(requestMyEventsStreams())

  return fetch(process.env.REACT_APP_BASE_URL + '/myevents/get_events',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ userId })
    })
    .then(
      response => response.json(),
      error => console.log('An error occurred', error)
    )
    .then(json => dispatch(receiveMyEventsStreams(json)))
}

export const fetchRemoveMyEvent = (eventId) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/myevents/delete_event',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ id: eventId })
    })
    .then(
      response => dispatch(removeMyEvent(eventId)),
      error => console.log('An error occurred', error)
    )
}

export const fetchUpdateMyEvent = (stream) => dispatch => {
  return fetch(process.env.REACT_APP_BASE_URL + '/myevents/update_event',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ ...stream })
    })
    .then(
      response => dispatch(updateMyEvent(stream)),
      error => console.log('An error occurred', error)
    )
}
